module.exports = __webpack_public_path__ + "img/eyein-partner-samsung.0bef5ae6.png";